import styled from '@emotion/styled'
import {COLORS} from '../constants'
import {PnlTone} from '../utils/kpiGrid'

/** One KPI tile: a bordered card holding an icon+label row, a primary value and a sub-line. */
export const Tile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  border: 1px solid ${COLORS.border};
  border-radius: 8px;
  background-color: ${COLORS.cardBg};
`

/** Top row of a tile: the metric icon, its label, and the info tooltip trigger. */
export const TileTop = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

/** Circular tint behind the metric's icon. */
export const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  color: ${COLORS.brand};
  background-color: ${COLORS.infoBg};
  flex-shrink: 0;
`

/** The metric's name. Takes the remaining width so the info icon sits at the far right. */
export const TileLabel = styled.span`
  flex: 1;
  min-width: 0;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: ${COLORS.mutedText};
`

/** Maps a PnL tone to the value colour (AC: positive green, negative red, neutral foreground grey). */
const toneColor = (tone: PnlTone): string => {
  if (tone === 'positive') return COLORS.success
  if (tone === 'negative') return COLORS.danger
  return COLORS.foreground
}

/** The tile's primary figure; coloured by {@link PnlTone} for the P/L tiles, neutral otherwise. */
export const TileValue = styled.div<{tone: PnlTone}>`
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
  color: ${({tone}) => toneColor(tone)};
`

/** Secondary caption under the value (e.g. "Lifetime", "3 sub-offers"). */
export const TileSub = styled.div`
  font-size: 11px;
  color: ${COLORS.mutedText};
`
